import { defineComponent as _defineComponent } from 'vue'
import InlineSvg from "vue-inline-svg";
import { computed, inject, onMounted, PropType, ref } from "vue";
import {
  ArrivalTimeOptionCode,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  ShowErrorModal,
} from "@/types";
import dayjs from "dayjs";
import { IBusStop } from "@/domain/entities/busStop";
import BusStopTimeRow from "@/components/line/BusStopTimeRow.vue";
import Calendar from "@/components/shared/Calendar.vue";
import { useArrivalTimes } from "@/composables/line/useArrivalTimes";
import { useRoute } from "vue-router";


const __default__ = {
  name: "PastArrivalTimeModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineTurnUid: {
    type: String,
    required: true,
  },
  busOrder: {
    type: Number,
    required: true,
  },
  busStops: {
    type: Array as PropType<IBusStop[]>,
    required: true,
    default: () => [],
  },
},
  emits: ["onClickCloseBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const props = __props;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const route = useRoute();

const yesterday = dayjs().add(-1, "day").format("YYYY-MM-DD");
const targetDate = ref(yesterday);
const displayDate = computed(() => targetDate.value.replace(/-/g, "."));

const { arrivalTimes: pastArrivalTimes, getArrivalTimes: getPastArrivalTimes } =
  useArrivalTimes(ArrivalTimeOptionCode.PAST);

const shouldShowModal = ref(true);
const closeModal = () => {
  route.meta.onBackHandlerList.pop();
  shouldShowModal.value = false;
  setTimeout(() => {
    emit("onClickCloseBtn");
  }, 300);
};

const shouldShowCalendar = ref(false);
const toggleShowCalendar = (show: boolean) => {
  shouldShowCalendar.value = show;
};

const canSearchNextDate = computed(() =>
  dayjs(targetDate.value).isBefore(dayjs(yesterday))
);

const updateTargetDate = (addingDay: number) => {
  targetDate.value = dayjs(targetDate.value)
    .add(addingDay, "day")
    .format("YYYY-MM-DD");
};

const updateTargetDateByCalendar = (date: string) => {
  targetDate.value = date;
  shouldShowCalendar.value = false;
  getPastArrivalTimes(
    props.lineTurnUid,
    props.busOrder,
    targetDate.value,
    undefined,
    undefined,
    handleError
  );
};

const searchNextDate = () => {
  if (!canSearchNextDate.value) return;
  updateTargetDate(1);
  getPastArrivalTimes(
    props.lineTurnUid,
    props.busOrder,
    targetDate.value,
    undefined,
    undefined,
    handleError
  );
};

const searchPreviousDate = () => {
  updateTargetDate(-1);
  getPastArrivalTimes(
    props.lineTurnUid,
    props.busOrder,
    targetDate.value,
    undefined,
    undefined,
    handleError
  );
};

const handleError = (title: string, result: any) => {
  showErrorModal(
    title,
    result.errorMessage,
    result.resultCode,
    result.errorTime
  );
};

const getArrivalTime = (busStopId: string) => {
  const target = pastArrivalTimes.value.find(
    (time) => time.busStopUid === busStopId
  );

  return target?.time ?? "-";
};

onMounted(() => {
  route.meta.onBackHandlerList.push(closeModal);

  getPastArrivalTimes(
    props.lineTurnUid,
    props.busOrder,
    targetDate.value,
    undefined,
    undefined,
    handleError
  );
});

const __returned__ = { emit, props, showErrorModal, route, yesterday, targetDate, displayDate, pastArrivalTimes, getPastArrivalTimes, shouldShowModal, closeModal, shouldShowCalendar, toggleShowCalendar, canSearchNextDate, updateTargetDate, updateTargetDateByCalendar, searchNextDate, searchPreviousDate, handleError, getArrivalTime, get InlineSvg() { return InlineSvg }, BusStopTimeRow, Calendar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})